
function Rights(){
    return (
        <div>
            <p className="rights">© 2025 Dang Khoa Nguyen. All rights reserved.</p>
        </div>
    )
}

export default Rights;